export const queryKeys = {
  getMembersByOrgId: (orgId: string) => ["getMembersByOrgId", orgId],
  getUserByEmail: (email: string) => ["getUserByEmail", email],
  getOrgSettings: (orgId: string) => ["getOrgSettings", orgId],
  getWorkTreeById: (projectId: string) => ["getWorkTreeById", projectId],
  getProjectItem: (projectId: string) => ["getProjectItem", projectId],
  getWorkItemById: (workItemId: string) => ["getWorkItemById", workItemId],
  getProjectItems: (orgId: string) => ["getProjectItems", orgId],
  getProjectNavItems: (orgId: string) => ["getProjectNavItems", orgId],
  getPersonWorkTrees: (personId: string, orgId: string) => [
    "getPersonWorkTrees",
    personId,
    orgId,
  ],
  getOrgPersonByUserId: (orgId: string, userId: string) => [
    "getOrgPersonByUserId",
    orgId,
    userId,
  ],
  /** Second segment scopes cache per signed-in user so post-login navigation does not reuse stale `/me` data. */
  getLoggedUser: (sessionIdentity?: string | null) => [
    "getLoggedUser",
    sessionIdentity ?? "no-session",
  ],
  getSaInvites: () => ["getSaInvites"],
  // Estimates
  getRecursiveWorkEstimates: (workId: string) => [
    "getRecursiveWorkEstimates",
    workId,
  ],
  getEstimates: (workId: string) => ["getEstimates", workId],
  getWorkTemplatesByProjectId: (workId: string) => [
    "getWorkTemplatesByProjectId",
    workId,
  ],
  findPublicWorkTemplates: (page: number, pageSize: number, search?: string) => [
    "findPublicWorkTemplates",
    page,
    pageSize,
    search ?? "",
  ],
  productsByOrgId: (orgId: string) => ["productsByOrgId", orgId],
  productsHubSummaries: (orgId: string) => ["productsHubSummaries", orgId],
  dashboardRecentActivity: (orgId: string) => ["dashboardRecentActivity", orgId],
  productTree: (productId: string) => ["productTree", productId],
  productFacet: (facetId: string) => ["productFacet", facetId],
  productFacetTypes: (orgId: string) => ["productFacetTypes", orgId],
  productFacetStatuses: (orgId: string) => ["productFacetStatuses", orgId],
  productFacetWorksByOrgId: (orgId: string) => ["productFacetWorksByOrgId", orgId],
  functionFacetIdsForProduct: (orgId: string, productRootId: string) => [
    "functionFacetIdsForProduct",
    orgId,
    productRootId,
  ],
  linkedWorkForFacet: (
    facetId: string,
    facetTypeKey: string,
    productRootId: string,
  ) => ["linkedWorkForFacet", facetId, facetTypeKey, productRootId],
  linkableWorkForFacet: (
    orgId: string,
    productRootId: string,
    facetId: string,
    facetTypeKey: string,
    search: string,
  ) => [
    "linkableWorkForFacet",
    orgId,
    productRootId,
    facetId,
    facetTypeKey,
    search,
  ],
  capabilityRollup: (
    orgId: string,
    productRootId: string,
    capabilityFacetId: string,
  ) => ["capabilityRollup", orgId, productRootId, capabilityFacetId],
  productMaturitySummary: (orgId: string, productRootId: string) => [
    "productMaturitySummary",
    orgId,
    productRootId,
  ],
  productProjectsExecution: (orgId: string, productRootId: string) => [
    "productProjectsExecution",
    orgId,
    productRootId,
  ],
  productIntelligence: (orgId: string, productRootId: string) => [
    "productIntelligence",
    orgId,
    productRootId,
  ],
  projectProductContext: (orgId: string, projectWorkId: string) => [
    "projectProductContext",
    orgId,
    projectWorkId,
  ],
  assignableFunctionFacets: (orgId: string) => [
    "assignableFunctionFacets",
    orgId,
  ],
  linkedFacetIdsForProduct: (orgId: string, productRootId: string) => [
    "linkedFacetIdsForProduct",
    orgId,
    productRootId,
  ],
  codeReposByProduct: (orgId: string, productRootId: string) => [
    "codeReposByProduct",
    orgId,
    productRootId,
  ],
  gitConnectionByOrg: (orgId: string) => ["gitConnectionByOrg", orgId],
  gitHubInstallationRepos: (orgId: string) => ["gitHubInstallationRepos", orgId],
  gitHubLinkableInstallations: (orgId: string) => [
    "gitHubLinkableInstallations",
    orgId,
  ],
  pullRequestsByCodeRepo: (orgId: string, codeRepoId: string) => [
    "pullRequestsByCodeRepo",
    orgId,
    codeRepoId,
  ],
  productFacetPullRequestsByFacet: (orgId: string, facetId: string) => [
    "productFacetPullRequestsByFacet",
    orgId,
    facetId,
  ],
  productFacetPullRequestsByRepo: (orgId: string, codeRepoId: string) => [
    "productFacetPullRequestsByRepo",
    orgId,
    codeRepoId,
  ],
  facetPullRequestNumbersByProduct: (orgId: string, productId: string) => [
    "facetPullRequestNumbersByProduct",
    orgId,
    productId,
  ],
  pullRequestsForProduct: (orgId: string, productId: string) => [
    "pullRequestsForProduct",
    orgId,
    productId,
  ],
  workProductFacetContext: (orgId: string, workId: string) => [
    "workProductFacetContext",
    orgId,
    workId,
  ],
  commentsByWorkId: (workId: string) => ["commentsByWorkId", workId],
  commentsByProductFacetId: (productFacetId: string) => [
    "commentsByProductFacetId",
    productFacetId,
  ],
};
